/**
 * Math Hover Hints
 *
 * Displays explanatory tooltips when hovering over math elements with hint data attributes.
 */

/**
 * Initialize hover hints for math elements
 */
function initMathHoverHints() {
  // Find all elements with data-math-hint attribute
  const hintElements = document.querySelectorAll('[data-math-hint]')

  hintElements.forEach(element => {
    const hintText = element.dataset.mathHint

    if (!hintText) return

    // Create tooltip element
    const tooltip = document.createElement('div')
    tooltip.className = 'math-hint-tooltip hidden absolute z-50 px-3 py-2 text-sm font-normal text-gray-700 dark:text-neutral-200 bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-lg shadow-lg max-w-xs'
    tooltip.innerHTML = hintText
    document.body.appendChild(tooltip)

    // Add hover class to element for styling
    element.classList.add('math-hint-trigger', 'cursor-help', 'relative')

    // Show tooltip on mouse enter
    element.addEventListener('mouseenter', (e) => {
      const rect = element.getBoundingClientRect()

      // Position tooltip above or below the element
      const spaceAbove = rect.top
      const spaceBelow = window.innerHeight - rect.bottom
      const tooltipHeight = 100 // Approximate height

      let top, left

      if (spaceBelow >= tooltipHeight || spaceBelow > spaceAbove) {
        // Show below
        top = rect.bottom + window.scrollY + 8
      } else {
        // Show above
        top = rect.top + window.scrollY - tooltipHeight - 8
      }

      left = rect.left + window.scrollX + (rect.width / 2)

      tooltip.style.top = `${top}px`
      tooltip.style.left = `${left}px`
      tooltip.style.transform = 'translateX(-50%)'
      tooltip.classList.remove('hidden')
      tooltip.classList.add('animate-in', 'fade-in', 'duration-200')
    })

    // Hide tooltip on mouse leave
    element.addEventListener('mouseleave', () => {
      tooltip.classList.add('hidden')
      tooltip.classList.remove('animate-in', 'fade-in')
    })

    // Hide tooltip on scroll
    window.addEventListener('scroll', () => {
      if (!tooltip.classList.contains('hidden')) {
        tooltip.classList.add('hidden')
      }
    })
  })
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMathHoverHints)
} else {
  initMathHoverHints()
}

// Re-initialize after Turbo navigation and after KaTeX renders
document.addEventListener('turbo:load', () => {
  // Wait a bit for KaTeX to render
  setTimeout(initMathHoverHints, 100)
})
document.addEventListener('turbo:render', () => {
  setTimeout(initMathHoverHints, 100)
})
